<template>
  <div class="product-card__benefits" data-eq-part="product-card__benefits">
    <List
        type="icon"
        icon="fa-solid fa-check"
        :items="benefits"
    />
  </div>
</template>

<script setup lang="ts">
import Product from '@/classes/Product';
import List from '@/components/List.vue';
import { computed } from 'vue';

const props = defineProps<{
  product: Product
}>();

const benefits = computed<string[]>(() => {
  const listOfBenefits = [...props.product.benefits];

  if (props.product.contractTermIsFixed) {
    listOfBenefits.push(`Vertragslaufzeit bis zum ${props.product.contractTermLabel}`);
  } else {
    listOfBenefits.push(`${props.product.contractTermLabel} Vertragslaufzeit`);
  }

  if (props.product.hasPriceGuarantee) {
    const priceGuaranteeInfo = `
      Zu deinem Vorteil sichern wir den reinen Energiepreis
      ${props.product.priceGuaranteeIsFixed ? 'bis zum' : ''}
      ${props.product.priceGuaranteeLabel}
      ab. Die Preissicherheit gilt ab dem voraussichtlichen Lieferbeginn und schützt dich vor
      Marktpreisschwankungen. Die Preissicherheit ist eingeschränkt, da wir gemäß §7 unserer AGB neue oder
      geänderte staatlich veranlasste Abgaben wie z. B. Steuern, die ca ⅔ des Gesamtpreises ausmachen,
      weitergegeben werden.
    `;
    if (props.product.priceGuaranteeIsFixed) {
      listOfBenefits.push([`Preisgarantie bis zum ${props.product.priceGuaranteeLabel}`, priceGuaranteeInfo]);
    } else {
      listOfBenefits.push([`${props.product.priceGuaranteeLabel} Preisgarantie`, priceGuaranteeInfo]);
    }
  }

  return listOfBenefits;
});
</script>

<style lang="scss">
@import "src/scss/component-helpers";

.product-card__benefits {
  text-align: left;
  padding: 20px 20px;

  @media(min-width: map-get($grid-breakpoints, 'lg')) {
    padding: 20px 40px;
  }
}
</style>
